import { Observable } from 'rxjs'
import { Product } from '@spartacus/core'

export abstract class MbProductByOriginalCodeAdapter {
  /**
   * Abstract method used to load product's data using the original product code, not the url encoded name.
   *
   * @param code The original code for given product
   */
  abstract loadProductByOriginalCode(code: string): Observable<Product | undefined>
}
